import { render } from "./SharedPostComponent.vue?vue&type=template&id=3ad77707"
import script from "./SharedPostComponent.vue?vue&type=script&lang=js"
export * from "./SharedPostComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__